import Draggable from 'react-draggable';
import React from 'react'
import {Paper} from "@mui/material";
export default function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} style={{width:'auto'}}/>
        </Draggable>
    );
}

